/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2022, Zumper
 */

// (This tracking implementation is being done in NR to simplify code for search result clicks
// and to avoid making a mess in many different files/packages.)

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event } from '@zcode/integrations'
import { AUTOCOMPLETE_RESULT_CLICK } from '../constants'

const getNameFromResult = (autocompleteResult) => {
  const { city, name, state, type } = autocompleteResult || {}
  if (type === 'city') {
    return `${name}, ${state}`
  }
  return `${name}, ${city && `${city}, `} ${state}`
}

export const trackAutocompleteResultClick =
  ({ result, index, searchTerm, allResults }) =>
  (dispatch, getState) => {
    if (!result || !searchTerm) {
      return
    }
    const state = getState()
    const user = getUser(state)

    const props = {
      searchTerm,
      searchResults: allResults?.map?.((result) => getNameFromResult(result)),
      selectedResult: getNameFromResult(result),
      selectedResultIndex: index,
    }

    if (result.type) {
      props.resultType = result.type === 'postcode' ? 'zipcode' : result.type
    }

    dispatch(event({ name: AUTOCOMPLETE_RESULT_CLICK, props, user }))
  }
